require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/node_modules/angular/index.js
// module id = 12
// module chunks = 0